import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, FileTextIcon } from 'lucide-react';
import { heroImage, heroStats } from '../data/profile';
import { PortraitFrame } from './PortraitFrame';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative isolate overflow-hidden bg-navy" data-id="element-90" data-mp="4n1lcrjx0csi">
      <img src={heroImage} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-45" data-id="element-91" data-mp="12a0mbehn46w7" />
      <div aria-hidden="true" className="absolute inset-0 bg-navy/85" data-id="element-92" data-mp="x8b9btauxj5h" />

      <div className="relative mx-auto max-w-shell px-6 pb-16 pt-32 lg:px-8 lg:pb-24 lg:pt-44" data-id="element-93" data-mp="s9zxxe4wz0l5">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-94" data-mp="nbewjbdxeav4">
          <div className="lg:col-span-7" data-id="element-95" data-mp="3d1sc51sntrv8">
            <motion.div initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE
          }} className="flex items-center gap-4" data-id="element-96" data-mp="3d2tpjcx5eqg4">
              <span className="h-px w-10 bg-gold" data-id="element-97" data-mp="3o7bzdvq44lfk" />
              <span className="text-[11px] font-semibold uppercase tracking-overline text-gold-light" data-id="element-98" data-mp="3o73p8bldju82">
                Executive Portfolio
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE,
            delay: 0.05
          }} className="mt-6 font-serif text-4xl leading-[1.12] text-white sm:text-5xl" data-id="element-99" data-mp="3e84nze2xv0v3">
              Executive Leadership at the Intersection of Defense, Governance, and
              Global Strategy.
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE,
            delay: 0.1
          }} className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-100" data-mp="2vgu075sif47f">
              Former Acting Under Secretary of the Navy&nbsp;&middot;&nbsp;Retired Rear
              Admiral&nbsp;&middot;&nbsp;Board Director&nbsp;&middot;&nbsp;Federal &amp;
              State Agency Chief.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE,
            delay: 0.15
          }} className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-101" data-mp="dd5e4putbl4n">
              <Link to="/experience" className="inline-flex items-center justify-center gap-2 bg-gold px-6 py-3.5 text-sm font-semibold text-navy transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-102" data-mp="15zq1lf863d2x">
                Explore Executive Experience
                <ArrowRightIcon className="h-4 w-4" data-id="element-103" data-mp="3lquffqlsob64" />
              </Link>
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 border border-white/30 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-gold hover:text-gold-light" data-id="element-104" data-mp="3hpse948bhp1i">
                <FileTextIcon className="h-4 w-4" data-id="element-105" data-mp="2697mihgpexxl" />
                Download Board Biography
              </Link>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.1
        }} className="lg:col-span-5" data-id="element-106" data-mp="2fzsswr2md6r2">
            <PortraitFrame data-id="element-107" data-mp="2p1jzrz8wbjmi" />
          </motion.div>
        </div>
      </div>

      <div className="relative border-t border-white/10 bg-indigo/70 backdrop-blur-sm" data-id="element-108" data-mp="2u03lbyjkutec">
        <dl className="mx-auto grid max-w-shell grid-cols-1 divide-y divide-white/10 px-6 sm:grid-cols-3 sm:divide-x sm:divide-y-0 lg:px-8" data-id="element-109" data-mp="umppi03fzixy">
          {heroStats.map((stat, i) => <motion.div key={stat.value} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.2 + i * 0.05
        }} className="flex flex-col py-7 sm:px-8 sm:first:pl-0 sm:last:pr-0" data-id="element-110" data-mp="zndp3a5ql83s" data-mpi={i}>
              <dt className="order-2 mt-2 text-sm font-semibold text-white" data-id="element-111" data-mp="9aqms9gd5wvf">
                {stat.label}
              </dt>
              <dd className="order-1 font-serif text-3xl text-gold-light lg:text-4xl" data-id="element-112" data-mp="3hrbvrq8zwpyj">
                {stat.value}
              </dd>
              <dd className="order-3 mt-1 text-sm text-slate-400" data-id="element-113" data-mp="3cp30uockbdts">{stat.detail}</dd>
            </motion.div>)}
        </dl>
      </div>
    </section>;
}